<template>
  <div>
    <Field
      :ref="iModel.firstname"
      v-slot="{ errors, field, value }"
      v-model="_firstname"
      tag="div"
      :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@FIRSTNAME'))"
      :rules="{ required: true }"
    >
      <QInput
        v-bind="field"
        :model-value="value"
        :label="$t('ETAB.FORMS.LABELS.@FIRSTNAME')"
        :name="iModel.firstname"
        type="text"
        :error="errors.length > 0"
        :error-message="errors[0]"
      />
    </Field>
    <Field
      :ref="iModel.lastname"
      v-slot="{ errors, field, value }"
      v-model="_lastname"
      tag="div"
      :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@LASTNAME'))"
      :rules="{ required: true }"
    >
      <QInput
        v-bind="field"
        :model-value="value"
        :label="$t('ETAB.FORMS.LABELS.@LASTNAME')"
        :name="iModel.lastname"
        type="text"
        :error="errors.length > 0"
        :error-message="errors[0]"
      />
    </Field>
  </div>
</template>

<script>
  import { Field } from "vee-validate";

  export default {
    components: {
      Field,
    },
    props: {
      lastname: { type: String, default: null },
      firstname: { type: String, default: null },
      iModel: { type: Object, default: () => ({}) },
    },
    emits: ["update:lastname", "update:firstname"],
    computed: {
      _lastname: {
        get() {
          return this.lastname;
        },
        set(value) {
          this.$emit("update:lastname", value);
        },
      },
      _firstname: {
        get() {
          return this.firstname;
        },
        set(value) {
          this.$emit("update:firstname", value);
        },
      },
    },
  };
</script>
